import { render, staticRenderFns } from "./ObitList.vue?vue&type=template&id=a14e0f06&scoped=true"
import script from "./ObitList.vue?vue&type=script&lang=js"
export * from "./ObitList.vue?vue&type=script&lang=js"
import style0 from "./ObitList.vue?vue&type=style&index=0&id=a14e0f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14e0f06",
  null
  
)

export default component.exports